import React, { useCallback } from 'react';
import Router from 'next/router';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import MuiButton from '@material-ui/core/Button';
import { useMediaQuery } from '@material-ui/core';
import { BREAKPOINTS } from 'src/utils/constants';
import Autocomplete from '../AutoComplete';

type StyledProps = {
  isMobile: boolean;
};
const SearchFormContainer = styled.div<StyledProps>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile && 'column') || 'row'};
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
`;
const StyledAutocomplete = styled(Autocomplete)<StyledProps>`
  flex-basis: ${({ isMobile }) => (isMobile && '100%') || '50%'};
  margin-left: ${({ isMobile }) => (isMobile && '0') || '10px'} !important;
  margin-top: ${({ isMobile }) => (isMobile && '10px') || '0px'} !important;
  background: white;
`;
const StyledTextField = styled(TextField)`
  background: white;
  flex-basis: 50%;
  //padding: 15px 0;
`;
const Button = styled(MuiButton)<StyledProps>`
  flex-basis: ${({ isMobile }) => (isMobile && '100%') || '20%'};
  margin-left: ${({ isMobile }) => (isMobile && '0') || '10px'} !important;
  margin-top: ${({ isMobile }) => (isMobile && '10px') || '0px'} !important;
  padding: ${({ isMobile }) => (isMobile && '12px 0') || 'auto'} !important;
`;
type SearchForm = {
  className?: string;
};
const SearchForm = ({ className }: SearchForm) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [location, setLocation] = React.useState('');

  const handleTermChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };
  const handleSelectLocation = useCallback(
    (val) => {
      setLocation(val);
    },
    [setLocation]
  );
  const handleSubmit = useCallback(() => {
    const query = [];
    if (searchTerm.length) {
      query.push(`to_search=${searchTerm}`);
    }
    if (location.length) {
      query.push(`location=${location}`);
    }
    Router.push(`/search${(query.length && '?') || ''}${query.join('&')}`);
  }, [searchTerm, location]);

  return (
    <SearchFormContainer className={className} isMobile={isMobile}>
      <StyledTextField
        onChange={handleTermChange}
        id="outlined-basic"
        label="Search keyword eg. Rental cars"
        variant="filled"
      />
      <StyledAutocomplete
        onChangeHandler={handleSelectLocation}
        isMobile={isMobile}
        variant="filled"
        label="Enter location eg. Islamabad"
      />
      <Button variant="contained" color="primary" isMobile={isMobile} onClick={handleSubmit}>
        Search
      </Button>
    </SearchFormContainer>
  );
};
export default SearchForm;
